export default function formatduration(value) {
  const hours = value.match(/(\d+)\s*h/);
  const minutes = value.match(/(\d+)\s*m/);
  const seconds = value.match(/(\d+)\s*s/);

  let days = '';
  if (hours && hours[1] > 24) {
    days = `${hours[1] / 24} days`;

    const hoursDiff = hours[1] % 24;
    if (hoursDiff > 0) {
      days = `${days} ${hoursDiff} hours`;
    }

    return days;
  }

  return `${hours ? `${hours[1]}h` : ''} ${minutes[1]}m ${seconds[1]}s`;
}
